import { render, staticRenderFns } from "./details.vue?vue&type=template&id=40b58ade&scoped=true"
import script from "./details.vue?vue&type=script&lang=ts"
export * from "./details.vue?vue&type=script&lang=ts"
import style0 from "./details.vue?vue&type=style&index=0&id=40b58ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b58ade",
  null
  
)

export default component.exports